import PropTypes from 'prop-types';
import MarkdownToHtml from '../../../MarkdownToHtml';

const PostCard = ({ post, onClickPostImage }) => {
  const ctaHref = post.ctaUrl || post.targetURL;
  const doShowCta = Boolean(post.ctaLabel && ctaHref);

  return (
    <div
      key={post.image + post.content}
      className={`p-2 sm:w-full w-full ${post.columnWidth ? `lg:${post.columnWidth}` : 'lg:w-1/2'} ${post.cssClass}`}
    >
      <div className="rounded overflow-hidden card bg-white shadow-lg">
        {post.image &&
          (post.targetURL ? (
            <a
              href={post.targetURL}
              onClick={() => onClickPostImage(post.targetURL)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={post.image} className="card-img-top w-full" alt="..." />
            </a>
          ) : (
            <img src={post.image} className="card-img-top w-full" alt="..." />
          ))}
        {post.content && (
          <div className="px-6 py-4">
            {post.title && <h2 className="font-bold text-xl mb-3">{post.title}</h2>}
            <MarkdownToHtml content={post.content} className="max-w-none text-gray-700 text-base" />
          </div>
        )}
        {doShowCta && (
          <div className={post.content ? 'px-6 pb-4' : 'px-6 py-4'}>
            <a
              href={ctaHref}
              onClick={() => onClickPostImage(ctaHref)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-button-theme rounded-md py-2 px-4 text-button-theme font-bold"
            >
              {post.ctaLabel}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

PostCard.propTypes = {
  post: PropTypes.shape({
    image: PropTypes.string,
    content: PropTypes.string,
    targetURL: PropTypes.string,
    title: PropTypes.string,
    columnWidth: PropTypes.string,
    cssClass: PropTypes.string,
    ctaLabel: PropTypes.string,
    ctaUrl: PropTypes.string,
  }),
  onClickPostImage: PropTypes.func,
};

PostCard.defaultProps = {
  post: {
    image: '',
    content: '',
    targetURL: '',
    title: '',
    columnWidth: '',
    cssClass: '',
    ctaLabel: '',
    ctaUrl: '',
  },
  onClickPostImage: () => {},
};
export default PostCard;
